import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from 'react';
import { getAuthorName, LogEntry } from './logEntry';
import { UserLink } from './userLink/userLink';
export const ConversationTransferred = ({ entry, }) => {
    const getText = useCallback(() => {
        var _a, _b;
        const destinationLabel = entry.destination_label || '';
        const destinationType = (_a = entry.destination_type) === null || _a === void 0 ? void 0 : _a.toLowerCase();
        const authorName = getAuthorName(entry);
        const authorLink = (_jsx(UserLink, Object.assign({ userId: entry.author.id }, { children: authorName })));
        switch (entry.activity_type) {
            case 'TRANSFER_INITIATED':
                return (_jsxs(_Fragment, { children: [(_b = entry.transfer_type) === null || _b === void 0 ? void 0 : _b.toLowerCase(), " conversation transfer is initiated by agent ", authorLink, " to ", destinationType, ' ', destinationLabel, "`"] }));
            case 'TRANSFER_FAILED':
                return `conversation transfer failed with status '${entry.reason}' by ${destinationType} ${destinationLabel}`;
            case 'TRANSFER_SUCCESSFUL':
                return `conversation successfully transferred to ${destinationType} ${destinationLabel}`;
            default:
                console.warn(`Unknown transfer status: ${entry.activity_type}`);
                return 'unknown transfer status';
        }
    }, [entry]);
    // For queue TRANSFER_SUCCESSFUL is generated on start, which sends before TRANSFER_INITIATED.
    // In order to prevent a potential confusion prevent skip log.
    if (entry.destination_type === 'QUEUE' &&
        entry.activity_type === 'TRANSFER_INITIATED') {
        return null;
    }
    const text = getText();
    return _jsx(LogEntry, { entry: entry, text: text });
};
